define(
	'Tavanoteam.TavanoTeam_Facets_Items_Info_Extension.FacetsItemsInfo'
	, [
		'underscore',
		'FacetItemsInfo1.View',
		'FacetItemsInfo2.View',
		'FacetItemsInfo3.View'
	]
	, function (
		_,
		FacetItemsInfo1View,
		FacetItemsInfo2View,
		FacetItemsInfo3View
	) {

		'use strict';

		return {

			mountToApp: function mountToApp(container) {

				var environment_component = container.getComponent("Environment");

				if (environment_component) {

					var PLP = container.getComponent('PLP');
					var layout = container.getComponent('Layout');

					var configurationDataOne = environment_component.getConfig('tavanoTeamFacetsItemsInfoExtension.FacetsItemsInfoExtension');
					var configurationDataTwo = environment_component.getConfig('tavanoTeamFacetsItemsInfoExtension.FacetsItemsInfoExtensionTwo');
					var configurationDataThree = environment_component.getConfig('tavanoTeamFacetsItemsInfoExtension.FacetsItemsInfoExtensionThree');

					if (PLP) {

						if (configurationDataOne) {

							var view_one = configurationDataOne.viewNameOne;

							if (view_one) {

								layout.addChildView(view_one, function () {

									return new FacetItemsInfo1View({ PLP: PLP, Data: configurationDataOne })
								});
							}
						}

						if (configurationDataTwo) {

							var view_two = configurationDataTwo.viewNameTwo;

							if (view_two) {

								layout.addChildView(view_two, function () {

									return new FacetItemsInfo2View({ PLP: PLP, Data: configurationDataTwo })
								});
							}
						}

						if (configurationDataThree) {

							var view_three = configurationDataThree.viewNameThree;

							if (view_three) {

								layout.addChildView(view_three, function () {

									return new FacetItemsInfo3View({ PLP: PLP, Data: configurationDataThree })
								});
							}
						}
					}
				}
			}
		};
	}
);
